<template>
  <q-table
    title="Doadores"
    :data="lastDonators"
    :columns="columns"
    row-key="id"
    :loading="$apollo.loading"
  >
    <template v-slot:top="props">
      <div class="row col-12 q-col-gutter-xs">
        <div class="col-12 text-center text-h3">Últimos doadores</div>
      </div>
    </template>
  </q-table>
</template>

<script>
import { LAST_DONATORS } from '../graphql/graphql'
import { DateTime } from 'luxon'

export default {
  name: 'LastDonators',
  apollo: {
    lastDonators: {
      query: LAST_DONATORS
      // pollInterval: 300, // ms
    }
  },
  data () {
    return {
      lastDonators: [],
      columns: [
        {
          name: 'id',

          label: 'ID do doador',
          align: 'left',
          field: 'id'

        }, {
          name: 'full_name',

          label: 'Nome do doador',
          align: 'left',
          field: 'full_name', /*,                        format: val => {
                            return `<a href="http://www.google.com">${val}</a>`
                        } */
          required: true

        }, {
          name: 'document',

          label: 'CPF do doador',
          align: 'left',
          field: 'document',
          format: val => {
            if (val) {
              let v = val
              v = v.replace(/\D/g, '')

              if (v.length <= 14) { // CPF
                // Coloca um ponto entre o terceiro e o quarto dígitos
                v = v.replace(/(\d{3})(\d)/, '$1.$2')

                // Coloca um ponto entre o terceiro e o quarto dígitos
                // de novo (para o segundo bloco de números)
                v = v.replace(/(\d{3})(\d)/, '$1.$2')

                // Coloca um hífen entre o terceiro e o quarto dígitos
                v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
              } else { // CNPJ
                // Coloca ponto entre o segundo e o terceiro dígitos
                v = v.replace(/\D/g, '') // Remove tudo o que não é dígito
                v = v.replace(/^(\d{2})(\d)/, '$1.$2') // Coloca ponto entre o segundo e o terceiro dígitos
                v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3') // Coloca ponto entre o quinto e o sexto dígitos
                v = v.replace(/\.(\d{3})(\d)/, '.$1/$2') // Coloca uma barra entre o oitavo e o nono dígitos
                v = v.replace(/(\d{4})(\d)/, '$1-$2')
              }

              return v
            }
          }

        }, {
          name: 'email',

          label: 'Email do doador',
          align: 'left',
          field: 'email'

        }, {
          name: 'created_at',

          label: 'Data de cadastro',
          align: 'left',
          field: 'created_at',

          format: val => {
            if (val) return DateTime.fromSQL(val, { locale: 'pt-br' }).toLocaleString(DateTime.DATETIME_SHORT)
          }
        }]
    }
  }
}
</script>

<style scoped>

</style>
